var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Nav'),_c('div',{class:['maqueta-create', 'contenedor-main', 'contenedor-full', _vm.paddingClass],style:(_vm.paddingStyle)},[_c('div',{staticClass:"container-fluid p-0"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }